import script from "./Questionnaire.vue?vue&type=script&setup=true&lang=ts"
export * from "./Questionnaire.vue?vue&type=script&setup=true&lang=ts"

import "./Questionnaire.vue?vue&type=style&index=0&id=5c837088&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c837088"]])

export default __exports__